import "./App.css";
import { Suspense, useMemo } from "react";
import { createHashRouter as createRouter, RouterProvider } from "react-router-dom";
import { RelayEnvironmentProvider } from "react-relay";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

import Profile from "./components/Profile";
import Home from "./components/Home";
import Projects from "./components/Projects";
import Project from "./components/Project";
import Resume from "./components/Resume";
import NotFound from "./components/NotFound";

import environment from "./Environment";
import photo from "./images/profile.jpg";

import ReactGA from "react-ga4";
ReactGA.initialize("AW-991893344", {
    testMode: process.env.NODE_ENV === "test" || process.env.NODE_ENV === "development",
});

const name = "David Adkins";

function App() {
    const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

    const theme = useMemo(
        () => createTheme({
            palette: {
                mode: prefersDarkMode ? "dark" : "light",
            },
        }),
        [prefersDarkMode]
    );

    const router = createRouter(
        [
            { path: "/", element: <Home />, errorElement: <NotFound /> },
            { path: "resume", element: <Resume /> },
            { path: "projects", element: <Projects /> },
            { path: "projects/:slug", element: <Project /> },
        ],
        { future: { v7_startTransition: true } }
    );

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <RelayEnvironmentProvider environment={environment}>
                <Container maxWidth="lg">
                    <Grid container spacing={3}>
                        <Grid item lg={3} md={3} sm={6} xs={12}>
                            <Profile name={name} photo={photo} />
                        </Grid>
                        <Grid item lg={9} md={9} sm={6} xs={12} data-testid="content-page" sx={{ backgroundColor: "#e0692d", padding: "0 24px 24px 0" }}>
                            <Suspense fallback={<CircularProgress />}>
                                <RouterProvider router={router} />
                            </Suspense>
                        </Grid>
                    </Grid>
                </Container>
            </RelayEnvironmentProvider>
        </ThemeProvider>
    );
}

export default App;
